import { render, staticRenderFns } from "./createNode.vue?vue&type=template&id=0ac981e2&scoped=true&"
import script from "./createNode.vue?vue&type=script&lang=js&"
export * from "./createNode.vue?vue&type=script&lang=js&"
import style0 from "./createNode.vue?vue&type=style&index=0&id=0ac981e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac981e2",
  null
  
)

export default component.exports